export enum FavoriteEvents {
    FavoriteControl = 'favorite.control',
    UnfavoriteControl = 'unfavorite.control',
    FavoriteSpace = 'favorite.space',
    UnfavoriteSpace = 'unfavorite.space',
    FavoritePlace = 'favorite.place',
    UnfavoritePlace = 'unfavorite.place'
}
